import { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import { globalStore } from './global.store';
import { dashboardStore } from './layout/dashboard/dashboard.store';
import { ticketupload } from './components/TicketUpload/ticketupload.store';
import { editAvatarStore } from './components/editAvatar/editAvatar.store';
import { cardsblockStore } from './components/cardsblock/cardsblock.store';
// import useGameClient from './hooks/useGameClient';
import ScrollToTop from './helpers/scroll_to_top';
import Toast from './components/toast';
import { OtherContentModal } from './components/otherContentModal';
import TicketUpload from './components/TicketUpload';
import EditAvatar from './components/editAvatar';
import AvatarEditor from './components/avatarEditor';
import OpenInApp from './components/openInApp';
import ShowAvatarSwitcher from './components/showAvatarSwitcher';
import Authorization from './modules/authorization';
import GuestPopup from "./components/GuestPopup";
import NotificationPopup from "./components/NotificationPopup";
import RoutesComponent from "./routes/RoutesComponent";

const App = observer(() => {
  // useGameClient();
  const {
    notification,
    otherContentModal,
    guestPopupState,
  } = globalStore;
  const { eventData } = ticketupload;
  const { openInAppData, showSwitcher } = cardsblockStore;
  const { showEditAvatarPopup, avatarEditor } = editAvatarStore;
  const { authPopupActive } = dashboardStore;

  return (
    <Suspense fallback={null}>
      <ScrollToTop />
      <RoutesComponent />
      <Toast />
      {notification && <NotificationPopup />}
      {guestPopupState && <GuestPopup />}
      {otherContentModal && <OtherContentModal />}
      {eventData?.eventType === 2 && <TicketUpload />}
      {showEditAvatarPopup && <EditAvatar />}
      {!!avatarEditor && <AvatarEditor />}
      {!!openInAppData && <OpenInApp />}
      {showSwitcher && <ShowAvatarSwitcher />}
      {authPopupActive && <Authorization />}
    </Suspense>
  );
});

export default App;
